module.exports = __webpack_public_path__ + "img/yq-pic4.c65ffc76.png";